import JSEncrypt from "jsencrypt";
import CryptoJS from "crypto-js";
import { encryptDecryptKey } from "../constants/Constants";

/**
 *
 * @param {*} length  of the request Id
 * @returns the new secret key
 */
export const generateSecreteKey = (length) => {
  return encryptDecryptKey;
  var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",
    result = "";
  for (var i = length; i > 0; --i)
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  return result;
};

/**
 * @param {*} secret is the randomly generated secret key
 * @param {*} id is the id of the api transaction
 * @returns the API request id with the secret key
 */

export const createRequestIds = (id, secret) => {
  var length = Math.floor(Math.random() * 10) + 3;
  var salt = Math.floor(Math.random() * 10) + 4;
  // var id = this.state.id;
  var requestId =
    Math.random().toString(36).substring(2, length) +
    Math.random().toString(36).substring(2, salt) +
    id;

  var secretNew = secret + generateSecreteKey(requestId.length);
  var latestTransaction = {
    requestId: requestId,
    secret: secretNew,
  };

  return latestTransaction;
};

/**
 *
 * @param {*} text the value which need to encrypt the object
 * @param {*} secret the randomly generated key to encrypt the object
 * @returns the object which has 2 parts. part1 contains the encrypted payload and
 *   part2 contains the encryption key wrapped with RSA encryption algorithm.
 */

export const encrypt = (text, secret) => {
  try {
    const sign = new JSEncrypt();
    const public_key = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAszJoMx0tynwrXAmMGGqhIxmZfgTZ/FeLz6gu7ePG8nVkfo+0PhVV34PAWzl+0//5MZxpHwMEFWr3ixTNkYnlEAjm9Kh3khR9yiemuMB9Tcju3ubCftb3XcgfDhN0BV3FtjeKGUZ9c5KZStfreccAr+obFxVtr637FC1iIxzxwhGSsaeoE/bTPBOCMsOqG7a3kMJgAHIrVK2W2Vlo+Amt1SzIa5pGmHMpVW0tXeOUSQUqr8hBVkjwql9LF7oLQg6k/8zY0SEyNtX/WN5Eb81jCjCdjB8iG9wqbhlE8fPmLWL45sbXCzov8PZxfmGshBF8Y/bqt867RgZe8EBdM0Q8XwIDAQAB`;

    sign.setPublicKey(public_key);

    const encryptedSecret = sign.encrypt(secret);
    console.log("Encrypted Secret:", encryptedSecret);

    const salt = CryptoJS.lib.WordArray.random(128 / 8);
    const iv = CryptoJS.lib.WordArray.random(128 / 8);
    const cryptoKey = CryptoJS.PBKDF2(secret, salt, {
      keySize: 256 / 32,
      iterations: 100,
    });

    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(text), cryptoKey, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });

    const transitmessage = {
      part1: salt.toString(CryptoJS.enc.Hex) + iv.toString(CryptoJS.enc.Hex) + encrypted.toString(),
      part2: encryptedSecret,
    };

    console.log("Transit Message:", transitmessage);

    return transitmessage;
  } catch (e) {
    console.error('Encryption error:', e);
    throw e;
  }
};

/**
 *
 * @param {*} text is the response of the REST API to decrept
 * @param {*} secret is the key of the encryption which needs to pass to get the decrepted value
 * @returns the decrycpted value as object
 */

export const decrypt = (text, secret) => {
  try {
    const salt = CryptoJS.enc.Hex.parse(text.substring(0, 32));
    const iv = CryptoJS.enc.Hex.parse(text.substring(32, 64));
    const encryptedText = text.substring(64);

    console.log("Salt:", salt.toString());
    console.log("IV:", iv.toString());
    console.log("Encrypted Text:", encryptedText);

    const key = CryptoJS.PBKDF2(secret, salt, {
      keySize: 256 / 32,
      iterations: 100,
    });

    const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });

    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    console.log("Decrypted Text:", decryptedText);

    return JSON.parse(decryptedText);
  } catch (e) {
    console.error('Decryption error:', e);
    throw e;
  }
};